import { useState } from 'react';
import { Trans, useLingui } from '@lingui/react';
import { Identity } from '@startuptools/business-ui/identity/Identity';
import { type ShareCertificate } from './ShareCertificatesInner';
import { ShareCertificatesInnerTable } from './ShareCertificatesInnerTable';
import { Card } from '@startuptools/ui/Card';
import { IconButton } from '@startuptools/ui/IconButton';
import { NumberFormat } from '@startuptools/ui/NumberFormat';
import { Table } from '@startuptools/ui/Table';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const ShareCertificatesTableRow = ({ row, showAvatar }: { row: ShareCertificate; showAvatar: boolean }) => {
  const { i18n } = useLingui();
  const [open, setOpen] = useState(false);

  return (
    <>
      <tr onClick={() => setOpen(!open)}>
        <td>
          <IconButton variant="outlined" onClick={() => setOpen(!open)}>
            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </td>
        <td>
          {row.shareholder.identity && (
            <Identity identity={row.shareholder.identity} editable={false} showAvatar={showAvatar} />
          )}
        </td>
        <td align="right">
          <NumberFormat maximumFractionDigits={0} locale={i18n.locale}>
            {row.totalNumberOfShares}
          </NumberFormat>
        </td>
        <td align="right">
          <NumberFormat maximumFractionDigits={0} locale={i18n.locale}>
            {row.blocks}
          </NumberFormat>
        </td>
        <td align="right">{row.certificateIssued ? <Trans id="Yes" /> : <Trans id="No" />}</td>
      </tr>

      {open && <ShareCertificatesInnerTable row={row} />}
    </>
  );
};

export const ShareCertificatesTable = ({ data }: { data: ShareCertificate[] }) => {
  return (
    <Card>
      <Table sx={{ '& th:first-of-type': { width: '50px' } }}>
        <thead>
          <tr>
            <th />
            <th>
              <Trans id="Shareholder" />
            </th>
            <th align="right">
              <Trans id="Total Number of Shares" />
            </th>
            <th align="right">
              <Trans id="Total Number of Blocks" />
            </th>
            <th align="right">
              <Trans id="Share Certificate Issued" />
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map(row => (
            <ShareCertificatesTableRow key={row.id} row={row} showAvatar={data.length <= 50} />
          ))}
        </tbody>
      </Table>
    </Card>
  );
};
